import { render, staticRenderFns } from "./DebtPayingAbilityTabs.vue?vue&type=template&id=524e7f1e&scoped=true&"
import script from "./DebtPayingAbilityTabs.vue?vue&type=script&lang=js&"
export * from "./DebtPayingAbilityTabs.vue?vue&type=script&lang=js&"
import style0 from "./DebtPayingAbilityTabs.vue?vue&type=style&index=0&id=524e7f1e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e7f1e",
  null
  
)

export default component.exports